import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class CompanyTypeEditService {

	private apiUrl = globalConst.baseAPI;

	constructor(private http: Http) { }

	loadCompanyType(token, ID) {

		return this.http
		.get(this.apiUrl + "company/v1/getcodcompany/" + ID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});

	}

	editCompanyType(token, companyType: any) {

		return this.http
		.put(this.apiUrl + "company/v1/updateculture", companyType, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/company-type/service/company-type-edit/company-type-edit.service.ts